class CheckboxGroupController {
	$onInit() {
		this.checkItems = this.checkItems || [];
	}

	change({value}, index) {
		this.onChange({
			$event: {
				value,
				index
			}
		});
	}
}

export default CheckboxGroupController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/checkbox-group/checkbox-group.controller.js